import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={22} height={20} fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M7.465 2H3a1 1 0 00-1 1v14a1 1 0 001 1h16a1 1 0 001-1V6a1 1 0 00-1-1h-9a1 1 0 01-.832-.445L7.465 2zm3.07 1H19a3 3 0 013 3v11a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3h5a1 1 0 01.832.445L10.535 3z" fill="#9738FF" /></svg>;
}
export default SvgComponent;